module.exports = __webpack_public_path__ + "static/media/calendar.fa9f860d.svg";